import { useState } from "react";
import { useTranslation } from "react-i18next";
import { translationKey } from "../i18n";

type backOptions = {
	backVisible: false;
} | {
	backVisible: true;
	backText?: translationKey;
	onBack: () => void;
};

type cancelOptions = {
	cancelVisible: false;
} | {
	cancelVisible: true;
	cancelText?: translationKey;
	onCancel: () => void;
};

interface nextOptions {
	nextDisabled?: boolean;
	nextText?: translationKey;
	onNext?: () => void;
}

type naviButtonsOptions = backOptions & cancelOptions & nextOptions;

export const NaviButtons = (options: naviButtonsOptions) => {
	const { t } = useTranslation();
	const [cancelConfirmationVisible, setCancelConfirmationVisible] = useState(false);

	return (
		<>
			<div className="row" id="form-nav">
				<div className="col-md-12">
					<div className="form-nav">
						{options.backVisible && (
							<button type="button" className="btn secondary" onClick={options.onBack}>
								{t(options.backText ?? "previous")}
							</button>
						)}
						{options.cancelVisible && (
							<button
								type="button"
								className="btn secondary cancelbutton"
								onClick={() => setCancelConfirmationVisible(true)}
							>
								{t(options.cancelText ?? "cancel")}
							</button>
						)}
						<button type="submit" className="btn" onClick={options.onNext} disabled={options.nextDisabled}>
							{t(options.nextText ?? "next")}
						</button>
					</div>
				</div>
			</div>
			{options.cancelVisible && cancelConfirmationVisible && (
				<div className="modal active">
					<div className="modal-backdrop"></div>
					<div className="modal-window-wrapper">
						<div className="modal-window">
							<p className="text-center">{t("cancelConfirmationTitle")}</p>
							<p className="text-center">{t("cancelConfirmationQuestion")}</p>
							<div className="modal-actions">
								<button type="button" className="btn secondary" onClick={options.onCancel}>
									{t("cancel")}
								</button>
								<button type="button" className="btn" onClick={() => setCancelConfirmationVisible(false)}>
									{t("continueOrder")}
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};
